var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.data.location)?_c('div',{staticClass:"location"},[_vm._v(" "+_vm._s(_vm.$store.getters.data.location)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }